import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/group.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3afbaca8")

_pushScopeId("data-v-3afbaca8")
const _hoisted_1 = { class: "desktop-grid" }
const _hoisted_2 = { class: "w100" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"width":"5%"} }
const _hoisted_5 = { class: "thead-cell-center" }
const _hoisted_6 = { style: {"width":"20%"} }
const _hoisted_7 = {
  style: {"width":"5%"},
  class: "text-center"
}
const _hoisted_8 = { class: "thead-cell-center" }
const _hoisted_9 = {
  class: "thead-cell-center",
  style: {"width":"5%"}
}
const _hoisted_10 = {
  class: "desktop-table-action",
  style: {"width":"5%"}
}
const _hoisted_11 = { class: "thead-cell-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("td", { style: {"width":"20%"} }, " Url ", -1)
const _hoisted_14 = {
  style: {"width":"5%"},
  class: "text-center"
}
const _hoisted_15 = { class: "thead-cell-center" }
const _hoisted_16 = {
  class: "thead-cell-center",
  style: {"width":"5%"}
}
const _hoisted_17 = {
  class: "desktop-table-action",
  style: {"width":"3%"}
}
const _hoisted_18 = { class: "thead-cell-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  class: "group-icon",
  src: _imports_0
}, null, -1)
const _hoisted_22 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_23 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_24 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_25 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "desktop-table-text-setting cuted-cell drag-handle" }
const _hoisted_30 = { class: "desktop-table-text-setting text-center drag-handle" }
const _hoisted_31 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_32 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_33 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_34 = {
  key: 0,
  class: "status-green"
}
const _hoisted_35 = {
  key: 1,
  class: "status-red"
}
const _hoisted_36 = { class: "desktop-table-action text-center" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "group-icon",
  src: _imports_0
}, null, -1)
const _hoisted_41 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  class: "desktop-table-text-setting cuted-cell drag-handle",
  style: {"display":"table-cell"}
}
const _hoisted_46 = { style: {"overflow":"hidden","text-overflow":"ellipsis","display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical"} }
const _hoisted_47 = { class: "desktop-table-text-setting text-center drag-handle" }
const _hoisted_48 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_49 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_50 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_51 = {
  key: 0,
  class: "status-green"
}
const _hoisted_52 = {
  key: 1,
  class: "status-red"
}
const _hoisted_53 = { class: "desktop-table-action text-center" }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_draggable = _resolveComponent("draggable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("table", _hoisted_2, [
      _createVNode("thead", null, [
        (_ctx.props.promotedType != _ctx.PromotedType.UpperBanner)
          ? (_openBlock(), _createBlock("tr", _hoisted_3, [
              _createVNode("td", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-sort', 'Order'))),
                style: {"width":"8%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.promoPosition')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Order')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-sort', 'ProviderName'))),
                style: {"width":"10%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('promo.providerName')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderName')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-sort', 'ProductName'))),
                style: {"width":"15%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('product.productName')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductName')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('promo.price')), 1)
              ]),
              _createVNode("td", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-sort', 'FromDate'))),
                style: {"width":"7%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('promo.fromDate')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('FromDate')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('on-sort', 'ToDate'))),
                style: {"width":"7%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('promo.toDate')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ToDate')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('promo.description')), 1),
              _createVNode("td", _hoisted_7, [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('promo.photo')), 1)
              ]),
              _createVNode("td", _hoisted_9, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.isActive')), 1)
              ]),
              _createVNode("td", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('customerType.actions')), 1)
              ])
            ]))
          : (_openBlock(), _createBlock("tr", _hoisted_12, [
              _createVNode("td", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('on-sort', 'Order'))),
                style: {"width":"8%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.promoPosition')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Order')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('on-sort', 'FromDate'))),
                style: {"width":"7%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('promo.fromDate')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('FromDate')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('on-sort', 'ToDate'))),
                style: {"width":"7%"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('promo.toDate')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ToDate')]
                  }, null, 2)
                ])
              ]),
              _hoisted_13,
              _createVNode("td", _hoisted_14, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('promo.photo')), 1)
              ]),
              _createVNode("td", _hoisted_16, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.isActive')), 1)
              ]),
              _createVNode("td", _hoisted_17, [
                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('customerType.actions')), 1)
              ])
            ]))
      ]),
      (_ctx.props.promotedType != _ctx.PromotedType.UpperBanner)
        ? (_openBlock(), _createBlock("tbody", _hoisted_19, [
            _createVNode(_component_draggable, {
              class: "dragable-container",
              element: "table",
              handle: ".drag-handle",
              modelValue: _ctx.promotedProducts,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.promotedProducts = $event)),
              "item-key": "id",
              "scroll-sensitivity": 330,
              "force-fallback": true
            }, {
              item: _withId(({ element }) => [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_20, [
                    _createTextVNode(_toDisplayString(element.order) + " ", 1),
                    _hoisted_21
                  ]),
                  _createVNode("td", _hoisted_22, [
                    _createVNode(_component_router_link, {
                      to: { name: 'provider-view', params: { id: element.providerId } },
                      class: "text-link cuted-cell m-0"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(element.providerName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: { name: 'product', params: { id: element.productId } },
                      class: "text-link cuted-cell m-0"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(element.productName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_24, _toDisplayString(element.price) + " " + _toDisplayString(_ctx.getCurrencySymbol(element.currencyId)), 1),
                  _createVNode("td", _hoisted_25, [
                    (element.fromDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.formatLocalDate(element.fromDate)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_27, [
                    (element.toDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.formatLocalDate(element.toDate)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_29, _toDisplayString(element.description), 1),
                  _createVNode("td", _hoisted_30, [
                    (element.imagePath)
                      ? (_openBlock(), _createBlock("i", _hoisted_31))
                      : (_openBlock(), _createBlock("i", _hoisted_32))
                  ]),
                  _createVNode("td", _hoisted_33, [
                    (element.active)
                      ? (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('label.active')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('label.notactive')), 1))
                  ]),
                  _createVNode("td", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      to: { name: 'editPromoProduct', params: { id: element.id } },
                      class: "m-0"
                    }, {
                      default: _withId(() => [
                        _hoisted_37
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createBlock("tbody", _hoisted_38, [
            _createVNode(_component_draggable, {
              class: "dragable-container",
              element: "table",
              handle: ".drag-handle",
              modelValue: _ctx.promotedProducts,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.promotedProducts = $event)),
              "item-key": "id",
              "scroll-sensitivity": 330,
              "force-fallback": true
            }, {
              item: _withId(({ element }) => [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_39, [
                    _createTextVNode(_toDisplayString(element.order) + " ", 1),
                    _hoisted_40
                  ]),
                  _createVNode("td", _hoisted_41, [
                    (element.fromDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.formatLocalDate(element.fromDate)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_43, [
                    (element.toDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.formatLocalDate(element.toDate)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_45, [
                    _createVNode("span", _hoisted_46, _toDisplayString(element.url), 1)
                  ]),
                  _createVNode("td", _hoisted_47, [
                    (element.imagePath)
                      ? (_openBlock(), _createBlock("i", _hoisted_48))
                      : (_openBlock(), _createBlock("i", _hoisted_49))
                  ]),
                  _createVNode("td", _hoisted_50, [
                    (element.active)
                      ? (_openBlock(), _createBlock("span", _hoisted_51, _toDisplayString(_ctx.$t('label.active')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('label.notactive')), 1))
                  ]),
                  _createVNode("td", _hoisted_53, [
                    _createVNode(_component_router_link, {
                      to: { name: 'editPromoProduct', params: { id: element.id } },
                      class: "m-0"
                    }, {
                      default: _withId(() => [
                        _hoisted_54
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
    ])
  ]))
})